export const featureFlags = {
  newFeature: true,
  experimentalFeature: false,
  // Add more feature flags here
  streamlineRegistration: false,
  extendedRegistration: true,
};
